/**
 * Owns the click on the sticky bar's "ADD TO CART".
 *
 * snippets/sticky-add-to-cart-bar.liquid renders that button with no `on:click`, so
 * the theme's own handleAddToCartClick never binds and this is the only handler. It
 * mattered: handleAddToCartClick adds a plain unit and knows nothing about the free
 * gifts, so gifts silently never reached the cart.
 *
 * This lives beside the bar rather than inside bundle-selector.js, which is loaded
 * only by the bundle-selector block. On a template that renders the bar without that
 * block - the apparel product template - the module never loaded, nothing was
 * listening, and the sticky button was inert: clicking it left the cart at zero.
 * The bar snippet loads this file, so the bar and its handler ship together.
 */
document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const button = target.closest('[data-nb-sticky-add]');
  if (!button || button.hasAttribute('disabled')) return;

  event.preventDefault();

  // Preferred: the bundle CTA. Its own handler reads the selected tier, so the
  // quantity, gifts and add-ons all follow whatever the shopper picked.
  // #addToCartViaTheme adds the gifts, then clicks the buy-box button, which
  // upsell-kit.js intercepts to add the checked add-ons at the tier's quantity.
  const cta = document.querySelector('bundle-selector [data-bundle-cta]');
  if (cta instanceof HTMLElement) {
    cta.click();
    return;
  }

  // No bundle selector on this template (the warranty and apparel pages). Fall back
  // to the buy box's own add-to-cart, skipping any candidate inside the sticky bar so
  // this cannot hand the click back to itself.
  const fallback = Array.from(
    document.querySelectorAll('[ref="addToCartButton"], form[data-type="add-to-cart-form"] button[name="add"]')
  ).find((candidate) => !candidate.closest('sticky-add-to-cart'));

  if (fallback instanceof HTMLElement) fallback.click();
});
